//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SearchCondition, SearchProp } from "@/utils/dto/search.js";
import TheSwitch from "@/components/objects/public/TheSwitch.vue";
import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import { PublicObject } from "@/utils/dto/objects.js";
import isEmpty from "lodash/isEmpty.js"
import SearchMap from "@/components/search/SearchMap";

export default {
  name: "TheSearchByProps",
  components: { ObjectSnippet, TheSwitch, SearchMap },
  props: {
    mapSearch: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['toggle-view', 'show-button'],
  data() {
    return {
      /** @type Array.<SearchCondition> */
      conditions: [],
      propertiesTypes: [],
      findObjects: [],
      showDebug: false,
      searchQuery: {},
      perPage: 12,
      offset: 0,
      showConditions: true,
      showConditionsMobile: false,
      searchView: null,
      searchViewActivated: false,
      showMap: false,
      resultsGeodata: {},
      isEmpty: false,
      shareLink: '',
      typeViewPlacemark: 'circle'
    }
  },
  computed: {
    form() {
      return {
        conditions: this.conditions
      }
    },
    isStaging() {
      return process.env.isStaging
    }
  },
  watch: {
    mapSearch(newValue) {
      if (newValue === false) {
        this.showConditions = true;
        this.showMap = false;
      }

      if (this.searchViewActivated) {
        this.handleSubmit(true)
      }
    }
  },
  async mounted() {
    this.addCondition()
    this.$nextTick(() => {
      this.searchView = this.mapSearch
    });
    // if (this.$route.query.search) {
    //   await this.getChachedData()
    //   this.showMap = true
    // }
  },
  methods: {
    setGeoType({ i, type }) {
      this.conditions[i].geoType = type
      this.typeViewPlacemark = type
      this.handleSubmit()
    },
    swapConditions({ direction, index }) {
      const newPosIdx = direction + index
      if (newPosIdx < 0 || newPosIdx >= this.conditions.length) return
      const newConditions = structuredClone(this.conditions)
      newConditions[index] = this.conditions[newPosIdx]
      newConditions[newPosIdx] = this.conditions[index]
      this.conditions = newConditions
    },
    removeCondition(uuid) {
      this.conditions = this.conditions.filter(condition => condition.uuid !== uuid)
    },
    addCondition() {
      const conditions = new SearchCondition()
      conditions.props.push(new SearchProp())
      this.conditions.push(conditions)
    },
    buildSingleQuery(condition) {
      const propsConditions = {}
      const searchCondition = {
        'object_type': condition?.type.id
      }

      condition.props.forEach(item => {
        let query = {}
        if (item.prop) {
          if (['select', 'object'].includes(item.valueType)) {
            query = {
              in: {
                value: item.property.value
              }
            }
          } else if (item.valueType === 'date') {
            query = {
              gte: {
                value: item.property.date.vfrom
              },
              lte: {
                value: item.property.date.vto
              }
            }

          } else if (item.valueType === 'number') {
            if (item.operator === 'in') {
              query = {
                gte: {
                  value: item.property.value[0]
                },
                lte: {
                  value: item.property.value[1]
                }
              }
            } else {
              query[item.operator] = {
                value: item.property.value[0],
              }
            }

            Object.keys(query).forEach(key => {
              if (item.property.value_si) {
                query[key].si = item.property.value_si
              }
            })
          }

          propsConditions[item.prop.id] = query
        }
      })

      if (!isEmpty(propsConditions)) searchCondition['props'] = propsConditions

      return searchCondition
    },
    buildSearchQuery() {
      this.searchQuery = {
        props: {
          '$or': this.conditions.filter(x => x?.type).map(condition => this.buildSingleQuery(condition))
        }
      }
    },
    infiniteScroll($state) {
      this.performSearch()
        .then(items => {
          if (items && !items.length) {
            $state.complete()
          } else {
            $state.loaded()
          }
        })
    },
    manuallySearch() {
      this.offset = 0
      this.findObjects = []
      this.buildSearchQuery()
      this.performSearch()
    },
    async performSearch() {
      await this.$axios.post(`/public/objects/?offset=${this.offset}&limit=${this.perPage}&order=-id`, this.searchQuery)
        .then((resp) => {
          this.findObjects.push(...resp.data.items.map(obj => new PublicObject(obj)))

          this.offset = this.offset + this.perPage
          this.isEmpty = !resp.data.items.length
          return resp.data.items
        })
        .catch(() => {
          this.findObjects = []
          return []
        })
    },
    async handleMapSearch() {
      this.resultsGeodata = {}
      let promises = []
      this.buildSearchQuery()

      this.conditions.filter(x => x?.type).forEach((condition) => {
        promises.push(this.$axios.post(`/public/objects/for_map/?offset=0&limit=500&order=-id`, {
          props: { $or: [this.buildSingleQuery(condition)] }
        }).then((resp) => {
          resp.data.items.filter(x => x.map && Object.keys(x.map.geodata).length).forEach(item => {
            const itemEntries = Object.entries(item.map.geodata)
            itemEntries.forEach(y => {
              if (y.length) {
                this.resultsGeodata[y[0]] = y[1]
                if (condition.geoType === 'circle' || condition.geoType === 'type' || condition.geoType === 'photo')
                {
                  this.resultsGeodata[y[0]].type = 'circle' //condition.geoType
                }
                this.resultsGeodata[y[0]].object = item
              }
            })
          })
        })
        )
      })

      await Promise.all(promises)
      this.saveCache()

      this.isEmpty = !Object.values(this.resultsGeodata)
      this.findObjects = []
      this.showConditions = false
      this.showConditionsMobile = false
      this.showMap = true
    },
    async saveCache() {
      this.buildSearchQuery()
      await this.$axios.post(`${process.env.BASE_URL_V2}/public/cacher/`, { data: this.searchQuery })
        .then(({ data }) => {
          this.$router.push({ query: { search: data } })
          this.shareLink = document.URL
        })

    },
    handleSubmit(isInitWatch = false) {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.searchViewActivated = true
          this.showMap = false
          this.$emit('show-button', this.searchViewActivated)

          if(this.mapSearch && isInitWatch){
            this.isEmpty = true
            this.showMap = true
          }

          this.mapSearch ? this.handleMapSearch('polygon') : this.manuallySearch()
        } else {

        }
      })
    },
    async getChachedData() {
      await this.$axios.get(`${process.env.BASE_URL_V2}/public/cacher/${this.$route.query.search}/`)
        .then(({ data }) => {
          this.searchQuery = data.data
          this.convertCahedToConditions(data.data.props.$or)
          this.handleMapSearch()
        })
    },
    async convertCahedToConditions(queryItems) {
      if (!queryItems?.length) return
      this.conditions = []
      const types = await this.$store.dispatch('objects_types/fetchObjects', {  })
      queryItems.forEach(item => {
        const condition = new SearchCondition()
        let objectType = ''
        if (types?.items?.length) {
          objectType = types.items.find((type) => item.object_type === type.id).label
        }
        condition.type = {
          id: item.object_type,
          label: objectType
        }

        if (item.props) {
          condition.props = Object.entries(item.props).map(([key, value]) => {
            const searchProp = new SearchProp()
            searchProp.prop = { id: key, label: 'fds', data: {} } // TODO
            searchProp.propperty = { value: value.in.value, template: {}, uuid: '' }
            return searchProp
          })
        }

        this.conditions.push(condition)

      })
    },
    async copyLink() {
      await navigator.clipboard.writeText(document.URL)
        .then(() => this.$message.success('Ссылка скопирована'))
    },
    toggleMapView() {
      this.$emit('toggle-view', this.searchView)
    },
  }
}
